import React from 'react'
import Head from 'next/head'
import { FAQSlice } from 'interfaces/GeneratedLandingPage'

interface Props {
    faqItems: FAQSlice['items']
}

function FAQSchemaData({ faqItems }: Props) {
    const data = {
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqItems.map((item) => ({
            '@type': 'Question',
            name: item.question,
            acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
            },
        })),
    }

    return (
        <Head>
            <script type="application/ld+json">{JSON.stringify(data)}</script>
        </Head>
    )
}

export default FAQSchemaData
